import classnames from 'classnames';
import {type Moment} from 'moment';

import {Body} from '../../typography/body';

import {CELL_WIDTH} from './calendar-heatmap';
import {getBackgroundColor, getTextColor} from './helpers';
import type {
    CalendarHeatmapColorVariant,
    CalendarHeatmapDay as CalendarHeatmapDayType,
} from './types';

import styles from './calendar-heatmap.module.css';

type Props = {
    dateData: CalendarHeatmapDayType | undefined; // Data from API
    date: Moment | null; // a moment from getCalendarWeeks, includes dates in the future and other months
    onClick?: (day: CalendarHeatmapDayType) => void;
    colorVariant: CalendarHeatmapColorVariant;
};

export function CalendarHeatmapDay(props: Props) {
    const backgroundColor = props.date
        ? getBackgroundColor(props.dateData, props.colorVariant)
        : undefined;
    const handleClick =
        !props.onClick || !props.dateData ? undefined : () => props.onClick!(props.dateData!);

    return (
        <div
            onClick={handleClick}
            data-tip={props.dateData?.dataTip}
            className={classnames('flex align-center justify-center br-8', {
                [styles['day']]: props.onClick,
            })}
            style={{
                width: CELL_WIDTH,
                height: CELL_WIDTH,
                backgroundColor,
            }}
        >
            {props.date && (
                <Body size='normal' color={getTextColor(props.dateData, props.colorVariant)}>
                    {props.date.format('D')}
                </Body>
            )}
        </div>
    );
}
